<template>
  <div id="page1">
    <div class="home-page" v-for="(item, index) in imageList" :key="index">
      <p class="home-png">
        <img :src="item.src1" />
      </p>
      <p class="home-png">
        <img :src="item.src2" />
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "Product",
  data() {
    return {
      imageList: [
        {
          src1: require('../assets/product/product1-1.png'),
          src2: require('../assets/product/product1-2.jpg')
        },
        {
          src1: require('../assets/product/product2-1.png'),
          src2: require('../assets/product/product2-2.jpg')
        },
        {
          src1: require('../assets/product/product3-1.png'),
          src2: require('../assets/product/product3-2.jpg')
        },
        {
          src1: require('../assets/product/product4-1.png'),
          src2: require('../assets/product/product4-2.jpg')
        },
        {
          src1: require('../assets/product/product5-1.png'),
          src2: require('../assets/product/product5-2.jpg')
        },
        // {
        //   src1: require('../assets/product/product6-1.png'),
        //   src2: require('../assets/product/product6-2.jpg')
        // },
        // {
        //   src1: require('../assets/product/product7-1.png'),
        //   src2: require('../assets/product/product7-2.jpg')
        // },
        // {
        //   src1: require('../assets/product/product8-1.png'),
        //   src2: require('../assets/product/product8-2.jpg')
        // },
        // {
        //   src1: require('../assets/product/product9-1.png'),
        //   src2: require('../assets/product/product9-2.jpg')
        // }
      ]
    }
  }
}
</script>

<style scoped>
#page1{
  width: 100%;
  margin: 0;
}

#page1 .home-page:last-child{
    margin-bottom: 100px;
}
</style>